import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { IconPickerInput } from "./IconPickerInput";
import { HookFormIconPickerInputProps } from "./IconPickerInput.types";

export const HookFormIconPickerInput = <T extends FieldValues>({
  form,
  name,
  rules,
  onChange,
  ...props
}: HookFormIconPickerInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => (
        <IconPickerInput
          ref={field.ref}
          onChange={onChange}
          {...props}
          value={field.value}
          onChangeValue={(value) => {
            field.onChange(value);
          }}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
